import type { Except } from '@festina-life/core'
import type { ComponentProps } from 'react'

import { IdToLegalEntity } from './IdToLegalEntity'

type Props = Except<ComponentProps<typeof IdToLegalEntity>, 'kind'>

/** Alias for `IdToLegalEntity` with the `kind` fixed to be `"company"`. */
export const IdToCompany = (props: Props) => (
  <IdToLegalEntity kind="company" {...props} />
)
